// Groups a Subject/Unit's skills by DOK level for the printable
// DOK Skills Checklist. Pure data shaping only — no docx/rendering
// concerns live here, matching the separation already used for the
// parent-facing report (see studentReportData.js / studentReportPdf.js).
//
// Unlike the parent report, this checklist is a BLANK worksheet: it
// lists every skill for the unit (not just achieved ones), and
// carries no student-specific state — the teacher fills it in by
// hand after printing.

// Standard DOK (Depth of Knowledge) category names, fixed by level
// regardless of what any particular unit's DOKLevel.description says.
export const DOK_LEVEL_TITLES = {
    1: "Recall & Reproduction",
    2: "Skills & Concepts",
    3: "Strategic Thinking",
    4: "Extended Thinking",
};

export const buildDokChecklistData = ({
    subjectName,
    unitName,
    skills = [],
}) => {
    const dokGroups = [1, 2, 3, 4]
        .map((level) => {
            const skillsForLevel = skills
                .filter(
                    (skill) => Number(skill.dok_level) === level
                )
                .sort(
                    (a, b) => a.display_order - b.display_order
                )
                .map((skill) => ({
                    id: skill.id,
                    description: skill.skill_description,
                }));

            return {
                level,
                title: DOK_LEVEL_TITLES[level],
                skills: skillsForLevel,
            };
        })
        .filter((dok) => dok.skills.length > 0);

    return {
        generatedAt: new Date().toISOString(),
        subjectName: subjectName || "",
        unitName: unitName || "",
        dokGroups,
    };
};
